import styled from 'styled-components';
import {
  mobile_width_percentage,
  tablet_container_maxwidth,
  desktop_container_maxwidth_compact,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const EmailWebFormStyles = styled.div`
  border-top: 1px solid ${Colors.accent.grey5.standard};
  margin-top: 50px;

  .webform-container {
    display: flex;
    flex-direction: column;
    margin: auto;
    margin-bottom: 80px;
    width: ${mobile_width_percentage}%;
    padding-top: 50px;
    max-width: 1100px;
  }
  .caption {
    display: inline-block;
    margin-bottom: 25px;
    margin-top: 10px;
  }

  form {
    display: flex;
    flex-direction: row;
    width: 100%;

    .animated {
      flex-grow: 1;
      margin-bottom: -30px;
      margin-top: 14px;
    }

    .button {
      & > div {
        display: none;
      }

      .webform-button {
        font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
      }

      &.submitting {
        display: block;
        position: relative;

        .webform-button {
          visibility: hidden;
        }

        & > div {
          display: block;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -50%);
          top: 50%;
        }
      }
    }
  }

  .webform-form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .disclaimer {
    margin-top: 20px;
    width: 100%;
    font-size: 14px;
  }

  .webform-thankyou {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;

    svg {
      height: 50px;
      margin-top: -15px;
      margin-bottom: -15px;
      width: 50px;

      * {
        fill: ${Colors.accent.claytonGreen.standard};
      }
    }
  }

  // big screen
  @media screen and (min-width: ${desktop_container_maxwidth_compact}px) {
    .webform-container {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }

    .webform-form {
      width: 50%;
    }

    .webform-text {
      margin-right: 20px;
    }
    .caption {
      margin-bottom: 0;
    }
  }

  // small screen
  @media screen and (max-width: ${tablet_container_maxwidth}px) {
    form {
      display: block;
      .button {
        margin: auto;
        margin-top: 30px;
      }
    }
  }
`;
